import axios from 'axios';

const accessToken: string =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2NmI2MWZlMjBiNGJkZmViYTQ4MWVhYzUiLCJlbWFpbCI6InN3YWdnZXJAa2FuZW1hb25saW5lLmNvbSIsImlhdCI6MTcyMzIxMTc0NiwiZXhwIjoxNzM4NzYzNzQ2fQ.pp3N9TlJeL5ySWOhY3Na3dUFx_bmK-DIqvbgdg-ZhAo';
var localAccessToken = localStorage.getItem('accessToken');
var localRefreshToken = localStorage.getItem('refreshToken');

const axiosInstance = axios.create({
  baseURL: 'https://kanema.staticcomputersinc.com/api',
  responseType: 'json',
  headers: {
    // 'Content-Type': 'application/json',
    'Authorization': `Bearer ${localAccessToken}`,
  },
});

// Function to fetch a new access token
const fetchNewToken = async (): Promise<string> => {
  const response = await axios.get('https://kanema.staticcomputersinc.com/api/auth/refresh', {
    headers: {
      Authorization: `Bearer ${localRefreshToken}`,
    }
  });

  if (response.status === 200 && response.data.message.accessToken) {
    const newAccessToken = response.data.message.accessToken;
    const newRefreshToken = response.data.message.refreshToken; 

    localStorage.setItem('refreshToken', newRefreshToken);

    return newAccessToken; 
  } else {
    throw new Error('Failed to fetch new token');
  }
};

// Function to refresh the access token
const refreshToken = async () => {
  try {
    const newToken = await fetchNewToken(); 
    localStorage.setItem('accessToken', newToken);
    localAccessToken = newToken;
    axiosInstance.defaults.headers.Authorization = `Bearer ${localAccessToken}`;
  } catch (error) {
    console.error('Failed to refresh token:', error);
  }
};


// setInterval(refreshToken, 240000); 
setInterval(refreshToken, 10000); 

export { axiosInstance as AxiosInstance };